import { render, staticRenderFns } from "./FSatuanDialog.vue?vue&type=template&id=674cd364&scoped=true"
import script from "./FSatuanDialog.vue?vue&type=script&lang=js"
export * from "./FSatuanDialog.vue?vue&type=script&lang=js"
import style0 from "./FSatuanDialog.vue?vue&type=style&index=0&id=674cd364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674cd364",
  null
  
)

export default component.exports